<template>
  <div class="transaction-store-pagination">
    <b-row>
      <b-col
        lg="3"
        md="3"
        sm="12"
      >
        <p
          class="mt-3 text-dark"
          style="font-weight: 500"
        >
          Tổng số: {{ totalItems }}
        </p>
      </b-col>
      <b-col
        lg="9"
        md="9"
        sm="12"
      >
        <b-pagination-nav
          class="custom-pagination"
          v-show="totalPages >= 2"
          :link-gen="linkGen"
          :number-of-pages="totalPages"
          use-router
          @change="onPageChange"
          align="right"
          first-class="page-item-first btn btn-icon btn-sm mr-1 my-1"
          prev-class="page-item-prev btn btn-icon btn-sm mr-.5 my-1"
          next-class="page-item-next btn btn-icon btn-sm mr-1 my-1 ml-.5"
          last-class="page-item-last btn btn-icon btn-sm my-1 "
          page-class="btn btn-icon btn-sm border-0 mr-.5 my-1"
        >
          <template v-slot:first-text>
            <span>
              <i class="ki ki-bold-double-arrow-back icon-xs"></i>
            </span>
          </template>

          <template v-slot:prev-text>
            <i class="ki ki-bold-arrow-back icon-xs"></i>
          </template>

          <template v-slot:next-text>
            <i class="ki ki-bold-arrow-next icon-xs"></i>
          </template>

          <template v-slot:last-text>
            <span class="text-info">
              <i class="ki ki-bold-double-arrow-next icon-xs"></i>
            </span>
          </template>
        </b-pagination-nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'TransactionStorePagination',
  props: {
    totalItems: {
      type: Number,
      default: 0,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
  },
  methods: {
    /**
     * Generate link for pagination
     */
    linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`;
    },

    /**
     * Handle page change
     */
    onPageChange(page) {
      this.$emit('page-change', page);
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-store-pagination {
  /* Pagination styles */
}
</style>
